if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          triggerBtn: '.lbcard__popup-btn-trigger',
          closeBtn: '.lbcard__popup-btn-close',
          overlay: '.fixed-overlay',
        };

        // Find the parent lbcard wrapper
        this.card = this.closest('.lbcard');
        if (!this.card) return;

        this.triggerBtn = this.card.querySelector(this.selectors.triggerBtn);
        this.closeBtn = this.querySelector(this.selectors.closeBtn);
        this.overlay = this.querySelector(this.selectors.overlay);

        if (this.triggerBtn) {
          this.triggerBtn.addEventListener('click', this.open.bind(this));
        }
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', this.close.bind(this));
        }
        if (this.overlay) {
          this.overlay.addEventListener('click', this.close.bind(this));
        }

        // Close on Escape key
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      open() {
        this.classList.add('is-open');
        this.triggerBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.handleKeydown);
      }

      close() {
        this.classList.remove('is-open');
        this.triggerBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this.handleKeydown);
      }

      handleKeydown(e) {
        if (e.key === 'Escape') this.close();
      }
    }
  );
}
